import { render, staticRenderFns } from "./LoadPricesModal.vue?vue&type=template&id=167c18bc&"
import script from "./LoadPricesModal.vue?vue&type=script&lang=js&"
export * from "./LoadPricesModal.vue?vue&type=script&lang=js&"
import style0 from "./LoadPricesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports